import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Tabs } from "antd";

import NavigationButtons from "../sectionJobByMajor/components/NavigationButtons";
import { fields, positions, professions, titles } from "./components/data";
import JobList from "./components/JobList";

import "@/pages/a.css";

const { TabPane } = Tabs;

const SectionJobCareer = () => {
  const [activeCategory, setActiveCategory] = useState("professions");

  const categories = [
    { key: "professions", title: "nghề nghiệp", data: professions },
    { key: "positions", title: "vị trí", data: positions },
    { key: "fields", title: "lĩnh vực", data: fields },
    { key: "titles", title: "chức vụ", data: titles },
  ];

  const getCategoryTitle = (category) =>
    categories.find((c) => c.key === category)?.title || "";

  const getCategoryCount = (category) => {
    switch (category) {
      case "professions":
        return professions.length;
      case "positions":
        return positions.length;
      case "fields":
        return fields.length;
      case "titles":
        return titles.length;
      default:
        return 0;
    }
  };

  return (
    <section className="">
      <div className="rounded-t-lg p-4">
        <motion.div
          className={
            "w-full rounded-t-xl p-5 bg-gradient-to-tl from-green-400 via-green-600 to-green-700"
          }
          style={{
            backgroundSize: "200% 200%",
            animation: "gradient-animation 6s ease infinite",
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <div className="flex gap-4 flex-col lg:flex-row justify-between items-center mt-4">
            <div className="text-center lg:text-left w-full ">
              <h2 className="text-xl text-white sm:text-2xl md:text-3xl font-bold mt-3 ps-2 mb-4">
                Khám phá cơ hội việc làm theo {getCategoryTitle(activeCategory)}
              </h2>
              <p className="text-white ps-2">
                Tìm kiếm cơ hội việc làm phù hợp với bạn
              </p>
            </div>
            <div className="mt-4 sm:mt-0">
              <NavigationButtons
                prevID="prevJobCareer"
                nextID="nextJobCareer"
              />
            </div>
          </div>
        </motion.div>

        <Tabs
          defaultActiveKey={activeCategory}
          onChange={setActiveCategory}
          centered
          className="bg-white p-2 sm:p-4 border border-gray-200 select-none"
        >
          {categories.map((category) => (
            <TabPane
              key={category.key}
              tab={`${getCategoryTitle(category.key)} (${getCategoryCount(
                category.key
              )})`}
            >
              <AnimatePresence>
                <motion.div
                  key={category.key}
                  initial={{ opacity: 0, x: -100 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: 100 }}
                  transition={{ duration: 0.3 }}
                >
                  <JobList
                    list={category.data}
                    prevID="prevJobCareer"
                    nextID="nextJobCareer"
                  />
                </motion.div>
              </AnimatePresence>
            </TabPane>
          ))}
        </Tabs>
      </div>
    </section>
  );
};

export default SectionJobCareer;
